import service from '@/config/axios'

// 获取页面内容
const getContentPage = (params) => {
  return service.get('/api/content/page', { params })
}

// 获取所有页面
const getAllContentPages = () => {
  return service.get('/api/content/all')
}

// 获取网站配置

const getSiteConfig = () => {
  return service.get('/api/content/config', { rawResponse: true })
}
// 获取项目案例列表

const getProjects = () => {
  return service.get('/api/content/projects')
}


// 订阅邮件
const subscribeEmail = (email) => {
  // 后端参数从 URL 查询字符串获取，因此使用 params 传递
  return service.post('/api/subscription/subscribe', null, { params: { email },rawResponse: true })
}

// 取消订阅
const unsubscribeEmail = (email) => {
  return service.post('/api/subscription/unsubscribe', null, { params: { email } })
}

export { getContentPage, getAllContentPages, getSiteConfig, getProjects,subscribeEmail, unsubscribeEmail}
